// html 데이터를 Delta 형식으로 변환
export const htmlToDelta = (html) => {
    const delta = { ops: [] };
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const parseNode = (node, indentLevel = 0) => {
        switch (node.nodeType) {
            // text 데이터
            case Node.TEXT_NODE:
                if (node.textContent.trim() !== '') {
                    delta.ops.push({ insert: node.textContent+"\n" });
                }
                break;
            // html element 데이터
            case Node.ELEMENT_NODE:
                const tagName = node.tagName.toLowerCase();
                let attributes = {};
                let insertText = '';

                switch (tagName) {
                    case 'br':
                        delta.ops.push({ insert: "\n" });
                        break;
                    case 'strong':
                        parseChildren(node, { bold: true });
                        return;
                    case 'em':
                        parseChildren(node, { italic: true });
                        return;
                    case 'u':
                        parseChildren(node, { underline: true });
                        return;
                    case 's':
                        parseChildren(node, { strike: true });
                        return;
                    case 'h1':
                        // parseChildren(node, { header: 1 });
                        delta.ops.push({ insert: `${node.textContent}` });
                        delta.ops.push({ attributes: { header: 1 }, insert: '\n' });
                        return;
                    case 'h2':
                        // parseChildren(node, { header: 2 });
                        delta.ops.push({ insert: `${node.textContent}` });
                        delta.ops.push({ attributes: { header: 2 }, insert: '\n' });
                        return;
                    case 'blockquote':
                        // parseChildren(node, { blockquote: true });
                        delta.ops.push({ insert: `${node.textContent}` });
                        delta.ops.push({ attributes: { blockquote: true }, insert: '\n' });
                        return;
                    case 'pre':
                        // parseChildren(node, { 'code-block': true });
                        delta.ops.push({ insert: `${node.textContent}` });
                        delta.ops.push({ attributes: { 'code-block': true }, insert: '\n' });
                        return;
                    case 'a':
                        attributes.link = node.getAttribute('href');
                        parseChildren(node, attributes);
                        return;
                    case 'ul':
                        Array.from(node.children).forEach(child => {
                            parseNode(child, indentLevel);
                        });
                        return;
                    case 'ol':
                        Array.from(node.children).forEach(child => {
                            parseNode(child, indentLevel);
                        });
                        return;
                    case 'li':
                        insertText = node.childNodes[0] ? node.childNodes[0].textContent : '';
                        attributes.list = node.parentElement.tagName.toLowerCase() === 'ul' ? 'bullet' : 'ordered';
                        if (node.hasAttribute('data-checked')) {
                            attributes.list = node.getAttribute('data-checked') === 'true' ? 'checked' : 'unchecked';
                        }
                        if (indentLevel > 0) {
                            attributes.indent = indentLevel;
                        }
                        delta.ops.push({ insert: insertText });
                        if (Object.keys(attributes).length > 0) {
                            delta.ops.push({ attributes, insert: '\n' });
                        } else {
                            delta.ops.push({ insert: '\n' });
                        }
                        Array.from(node.childNodes).slice(1).forEach(child => {
                            parseNode(child, indentLevel + 1);
                        });
                        return;
                    case 'img':
                        delta.ops.push({ insert: { image: node.getAttribute('src') } });
                        return;
                    case 'iframe':
                        delta.ops.push({ insert: { video: node.getAttribute('src') } });
                        return;
                    default:
                        Array.from(node.childNodes).forEach(child => {
                            parseNode(child, indentLevel);
                        });
                        return;
                }
            default:
                break;
        }
      }

    const parseChildren = (node, attributes) => {
        Array.from(node.childNodes).forEach(child => {
            if (child.nodeType === Node.TEXT_NODE) {
                delta.ops.push({ attributes, insert: child.textContent });
            } else {
                parseNode(child);
            }
        });
        delta.ops.push({ insert: '\n' });
    }

    Array.from(doc.body.childNodes).forEach(node => parseNode(node));
    return delta;
};

// Delta 데이터를 html 형식으로 변환
export const deltaToHtml = (delta) => {
    const container = document.createElement('div');
    let listStack = [];
    let currentLine = '';
    let currentAttrs = {};
    let currentFormats = {};
    let listType = null;

    const closeAllLists = () => {
        listStack = [];
        listType = null;
    };

    const createInlineElement = (text, attributes) => {
        let el = document.createTextNode(text);

        if (!attributes) return el;

        if (attributes.bold) {
            const strong = document.createElement('strong');
            strong.appendChild(el);
            el = strong;
        }

        if (attributes.italic) {
            const em = document.createElement('em');
            em.appendChild(el);
            el = em;
        }

        if (attributes.underline) {
            const u = document.createElement('u');
            u.appendChild(el);
            el = u;
        }

        if (attributes.strike) {
            const s = document.createElement('s');
            s.appendChild(el);
            el = s;
        }

        if (attributes.link) {
            const a = document.createElement('a');
            a.href = attributes.link;
            a.target = '_blank';
            a.rel = 'noopener noreferrer';
            a.appendChild(el);
            el = a;
        }

        return el;
    };

    const renderInlineText = (parent, text, attrs) => {
        parent.appendChild(createInlineElement(text, attrs));
    };

    const appendListItem = (text, attrs) => {
        const type = (attrs.list === 'checked' || attrs.list === 'unchecked') ? 'check' :
                     attrs.list === 'ordered' ? 'ol' : 'ul';
        const indentLevel = attrs.indent || 0;

        while (listStack.length > 0 &&
              (listType !== type || listStack[listStack.length - 1].indentLevel > indentLevel)) {
            listStack.pop();
        }

        if (
            listStack.length === 0 ||
            listType !== type ||
            listStack[listStack.length - 1].indentLevel !== indentLevel
        ) {
            const newList = document.createElement(type === "check" ? "ul" : type);
            if (listStack.length > 0 && indentLevel > listStack[listStack.length - 1].indentLevel) {
                const parentLi = listStack[listStack.length - 1].element.lastElementChild;
                if (parentLi) parentLi.appendChild(newList);
            } else {
                container.appendChild(newList);
            }
            listStack.push({ element: newList, indentLevel });
            listType = type;
        }

        const li = document.createElement('li');
        if (attrs.list === 'checked' || attrs.list === 'unchecked') {
            li.setAttribute('data-checked', attrs.list === 'checked');
        }
        // renderInlineText(li, text.trim(), currentFormats);
        li.textContent = text.trim();
        listStack[listStack.length - 1].element.appendChild(li);
    };

    delta.ops.forEach((op) => {
        const opAttrs = op.attributes || {};

        if (typeof op.insert === 'string') {
            const lines = op.insert.split('\n');
            lines.forEach((line, idx) => {
                if (idx === lines.length - 1) {
                    currentLine += line;
                    currentFormats = opAttrs;
                } else {
                    const fullText = currentLine + line;
                    const attrs = opAttrs || currentAttrs || {};

                    if (attrs.list) {
                        appendListItem(fullText, attrs);
                    } else if (attrs.header) {
                        const h = document.createElement('h' + attrs.header);
                        renderInlineText(h, fullText.trim(), currentFormats);
                        container.appendChild(h);
                        closeAllLists();
                    } else if (attrs.blockquote) {
                        const bq = document.createElement('blockquote');
                        renderInlineText(bq, fullText.trim(), currentFormats);
                        container.appendChild(bq);
                        closeAllLists();
                    } else if (attrs['code-block']) {
                        const pre = document.createElement('pre');
                        renderInlineText(pre, fullText.trim(), currentFormats);
                        container.appendChild(pre);
                        closeAllLists();
                    } else {
                        if (fullText.trim() === '') {
                            container.appendChild(document.createElement('br'));
                        } else {
                            const p = document.createElement('p');
                            renderInlineText(p, fullText.trim(), currentFormats);
                            container.appendChild(p);
                        }
                        closeAllLists();
                    }

                    currentLine = '';
                    currentFormats = {};
                    currentAttrs = {};
                }
            });
        } else if (op.insert.image) {
            const img = document.createElement('img');
            img.src = op.insert.image;
            img.className = 'ql-image';
            container.appendChild(img);
            closeAllLists();
        } else if (op.insert.video) {
            const iframe = document.createElement('iframe');
            iframe.src = op.insert.video;
            iframe.className = 'ql-video';
            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute('allowfullscreen', 'true');
            container.appendChild(iframe);
            closeAllLists();
        }

        if (op.attributes) {
            currentAttrs = op.attributes;
        }
    });

    if (currentLine.trim()) {
        const p = document.createElement('p');
        renderInlineText(p, currentLine.trim(), currentFormats);
        container.appendChild(p);
    }

    return container.innerHTML;
};
